import { defineStore } from 'pinia';
import contractApi from "@/api/contractApi.js";
import facilityApi from "@/api/facilityApi.js";


export const useContractsStore = defineStore('contractsStore', {
    state: () => ({
        contracts: [],
        contract: null,
    }),

    actions: {
        // Новый список "как у customers": пагинация, поиск q, статус ACTIVE/ARCHIVED
        async loadContractsList({ page = 1, page_size, search = '', is_active, ordering } = {}) {
            try {
                const status = typeof is_active === 'boolean'
                    ? (is_active ? 'ACTIVE' : 'ARCHIVED')
                    : undefined;

                const resp = await contractApi.getContracts({
                    page,
                    page_size,
                    q: search || undefined,
                    status,
                    ordering
                });
                // не сохраняем в state, просто возвращаем как у customers
                return resp; // { count, results }
            } catch (error) {
                console.error("Ошибка загрузки списка договоров:", error);
                throw error;
            }
        },


        // Новый экшен для ContractsList: список по customer или facility
        async fetchContractsList({ customer_id, facility_id, customer, facility, page = 1 } = {}) {
            try {
                const data = await contractApi.getContracts({ customer_id, facility_id, customer, facility, page });
                // Ничего не ломаем: при необходимости можно сохранить в состояние
                // this.contracts = Array.isArray(data?.results) ? data.results : [];
                return data; // { count, next, previous, results }
            } catch (error) {
                console.error("Ошибка получения списка договоров:", error);
                throw error;
            }
        },

        async loadContract(id) {
            try {
                this.contract = null;
                this.contract = await contractApi.getContractDetail(id);
            } catch (error) {
                console.error('Ошибка загрузки контракта:', error);
            }
        },

        // Новая ручка: /api/contracts/{target}/{pk}?q=...
        async loadContractsByTarget({ target, id, page = 1, search = '' } = {}) {
            try {
                return await contractApi.listByTarget({
                    target,
                    id,
                    page,
                    q: search || undefined,
                }); // { count, results }
            } catch (error) {
                console.error('Ошибка загрузки договоров по сущности:', error);
                throw error;
            }
        },
        // Получить следующий номер и дату
        async fetchNextNumber() {
            try {
                return await contractApi.getNextNumber(); // { sequence, date, number }
            } catch (error) {
                console.error('Ошибка получения следующего номера договора:', error);
                throw error;
            }
        },

        // Создать договор
        async createContract({ facility, customer }) {
            try {
                return await contractApi.createContract({ facility, customer });
            } catch (error) {
                console.error('Ошибка создания договора:', error);
                throw error;
            }
        },
        // Обновить договор
        async updateContract(id, { customer }) {
            try {
                const updated = await contractApi.updateContract(id, { customer });
                // Обновляем текущий договор в store, если это он
                if (this.contract?.id === id) {
                    this.contract = updated;
                }
                return updated;
            } catch (error) {
                console.error('Ошибка обновления договора:', error);
                throw error;
            }
        },
        async archiveContract(id) {
            try {
                const res = await contractApi.archiveContract(id);
                this.contract = null;
                return res;
            } catch (error) {
                console.error('Ошибка архивирования договора:', error);
                throw error;
            }
        },
        async unarchiveContract(id) {
            try {
                const res = await contractApi.unarchiveContract(id);
                await this.loadContract(id);
                return res;
            } catch (error) {
                console.error('Ошибка разархивирования договора:', error);
                throw error;
            }
        },

        async deleteContract(id) {
            try {
                const res = await contractApi.deleteContract(id);
                this.contract = null;
                return res;
            } catch (error) {
                console.error('Ошибка удаления договора (alias delete):', error);
                throw error;
            }
        },


    },


});
